// import Vue from 'vue'
// // 按钮级别权限 -- 比对元素  元素绑定角色值<<-->>登录获取值
// // 元素绑定角色值 →_→ 接收 字符串 或 数组
// // 登录获取值 →_→  接收 字符串
// // 执行指令  元素插入时 获取 元素指令角色 与原型对比 执行下方 Vue.prototype.$_has
// /** 权限指令**/
// let has = Vue.directive('has', {
//         inserted: function(el, binding) { // 注意使用inserted周期，不要使用 bind 不然无法删除元素
//             let className = binding.value.class // v-has 接收数组对象
//             if (el.parentNode && !Vue.prototype.$_has(className)) { // 检查
//                 el.parentNode.removeChild(el)
//             }
//         }
//     })
//     //  元素指令值与角色值对比 如果不匹配  返回false
//     // 权限检查
// Vue.prototype.$_has = function(val) {
//     let isShow = false
//     let btnPermissions = sessionStorage.getItem('btnPermissions')
//     if (btnPermissions === undefined || btnPermissions == null) {
//         return false
//     }
//     if (typeof(val) === 'string') {
//         if (val === btnPermissions) {
//             isShow = true
//         }
//         return isShow
//     } else {
//         for (let i = 0; i < val.length; i++) {
//             const showIs = val[i]
//             if (showIs === btnPermissions) {
//                 isShow = true
//             }
//         }
//         return isShow
//     }
// }
// export { has }

export function hasPermission(permission) {
    // alert(permission)
    // var str = '001,00101,0010101,0010102,0010103,0010104,0010105,0010106,00103,00102,00104,00105,012,002,003,004,005,006,007,008,009,010,011,0010107,0010108,0010109,0010301,0010302,0010303,0010401,0010402,0010403,0010404,0010405,00801,00802,0080101,0080102,0080103,0080104,0080105,0080106,0080107,0080108,0080109,0080111,0080112,0080113,0080114,0080115,0080116,0080117,0080201,0080202,0080203,0080204,0080205,0080206,0080207,0080208,0080209,0080210,0080211,0020101,0020102,0020103,0020104,0020105,0020106,0020107,0020108,0020109,0020111,0020112,0020113,0020114,0020115,0020116,0020117,0030101,0030102,0030103,0030104,0030105,0030106,0030107,0030108,0030109,0030111,0030112,0030113,0030114,0030115,0030116,0030117,0040101,0040102,0040103,0040104,0040105,0040106,0040107,0040108,0040109,0040111,0040112,0040113,0040114,0040115,0040116,0040117,0050101,0050102,0050103,0050104,0050105,0050106,0050107,0050108,0050109,0050111,0050112,0050113,0050114,0050115,0050116,0050117'

    // sessionStorage.setItem("jsonKey", str);
    //第一版判断字符串中是否有某个元素，会有冲突。
    // var result = sessionStorage.getItem("jsonKey");
    // return result.indexOf(permission) > -1;

    //判断数组中是否含有某个元素20200828
    var result = sessionStorage.getItem("jsonKey");
    var isTrue = false;
    if(result != null){
        var resultArr = result.split(',');
        isTrue = resultArr.indexOf(permission) > -1
    }
    return isTrue;
}


// WEBPACK FOOTER //
// ./src/assets/js/common/hasPermission.js